import { color_logo } from "constant/imagePath";
import ModalSkeleton from "modals/ModalSkeleton";
import classes from "./PwaReminderModal.module.css";

export default function PwaReminderModal({ show, setShow }) {
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      width="480px"
      backdrop
      enableEscKey={false}
    >
      <div className={classes.content}>
        <img src={color_logo} alt="Fluency Compass" className={classes.logo} />

        <h2 className={classes.title}>Use the Fluency Compass App</h2>
        <p className={classes.subtitle}>
          For the best experience — especially during tests — please install and
          use the Fluency Compass app on your iPad instead of the browser.
        </p>

        <div className={classes.stepsCard}>
          <h3 className={classes.stepsTitle}>How to install on iPad</h3>
          <ol className={classes.steps}>
            <li>
              Open this page in <strong>Safari</strong> (not Chrome or another
              browser)
            </li>
            <li>
              Tap the{" "}
              <span className={classes.shareIcon}>
                <ShareIcon />
              </span>{" "}
              <strong>Share</strong> button at the bottom of the screen
            </li>
            <li>
              Scroll down and tap <strong>"Add to Home Screen"</strong>
            </li>
            <li>
              Tap <strong>Add</strong> in the top-right corner
            </li>
            <li>
              Open the <strong>Fluency Compass</strong> icon from your home
              screen
            </li>
          </ol>
        </div>

        <button className={classes.dismissBtn} onClick={() => setShow(false)}>
          Got it, continue in browser
        </button>
      </div>
    </ModalSkeleton>
  );
}

function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="currentColor"
      style={{ verticalAlign: "middle", display: "inline-block" }}
    >
      <path d="M12 2l-4 4h3v7h2V6h3l-4-4zm-6 14v4h12v-4h-2v2H8v-2H6z" />
    </svg>
  );
}
